import { render } from "./ApprovalContent.vue?vue&type=template&id=0724c979"
import script from "./ApprovalContent.vue?vue&type=script&lang=js"
export * from "./ApprovalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__